module.exports = new __parcel__URL__("postBG_blob.27b17b4b.webp").toString();